module.exports = __webpack_public_path__ + "img/prize-03.420cf2e8.png";